import React, {useContext, useEffect} from "react";
import {Block, Button, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import {observer} from "mobx-react";
import "./style.scss";
// core
import {LayoutContext} from "../../../../core/Contexts";
// components
import {useNavigate} from "react-router-dom";
import BonusesService from "../../../../services/BonusesService";

export default React.memo(
    observer(function MyDealers() {
        const contextLayout = useContext(LayoutContext);
        const navigate = useNavigate();
        const {t} = useTranslation();

        const onClick = () => {
            navigate("/dealers/");
        };

        useEffect(() => {
            BonusesService.getLevelsBonuses();
            BonusesService.getLevelsSummary();
        }, []);

        const lineFunction = (text: string, number: number) => {
            return (
                <Typography as="div" className="bl-my-dealers-text">
                    <Typography
                        color="rgba(255, 255, 255, 0.5)"
                        size={_.gte(contextLayout?.width, 768) ?? 0 ? 17 : 14}
                    >
                        {text}
                    </Typography>
                    <Typography as="span" size={_.gte(contextLayout?.width, 768) ?? 0 ? 17 : 14}>
                        {number}
                    </Typography>
                </Typography>
            );
        };

        return (
            <Typography as="div" className="bl-my-dealers">
                <Block title={t("Мои дилеры ")}>
                    {lineFunction(t("Всего дилеров"), BonusesService.totalCount)}
                    {lineFunction(t("Накоплено"), BonusesService.summarySum)}
                    {lineFunction(t("Начисляются"), BonusesService.summaryProcessSum)}
                    <Button type="primary" onClick={onClick}>
                        {t("Дилеры")}
                    </Button>
                </Block>
            </Typography>
        );
    })
);
